import { Injectable, Inject } from '@angular/core';
import { IMyImunifyState } from 'app/services/my-imunify-state';
import { PaymentSuccessComponent } from 'app/utils/modals/payment-success/payment-success.component';
import { PAYMENT_SUCCESS_DELAY_MS } from 'app/components/nav-root/nav-root.component';
import { MyImunifyService } from 'app/services/my-imunify';
import { CallOnce } from 'app/utils/call-once';
import { ProtectionBenefitsComponent } from 'app/utils/modals/protection-benefits/protection-benefits.component';
import { ModalService } from 'app/utils/modals/modal.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ClAnalytics } from 'app/services/cl-analytics';

@Injectable()
export class MyImunifyPromoDialogService {
    private promoModalRef: MatDialogRef<any>;

    constructor(
        @Inject('Window') private window: Window,
        private clAnalytics: ClAnalytics,
        private modalService: ModalService,
        private myImunifyService: MyImunifyService,
    ) {}

    openPromoModal(sendAnalytics = false): void {
        this.promoModalRef = this.modalService.getDialogRef(ProtectionBenefitsComponent, {
            data: { sendAnalytics },
            width: '978px',
            autoFocus: false,
        });
    }

    @CallOnce()
    checkNeedToShowMyImunifyUpgradeDialog(username: string): void {
        const showDialog = this.window.location.search.includes('show_cleanup_dialog=true');
        if (showDialog && !localStorage.getItem(`myImunifyUpgradeDialogWasShownFor_${username}`)) {
            localStorage.setItem(`myImunifyUpgradeDialogWasShownFor_${username}`, 'true');
            setTimeout(() => {
                this.openPromoModal(true);
            }, 1000);
        }
    }

    handlePayoutEvent(event: MessageEvent, myImunifyState: IMyImunifyState): void {
        if (event.data === 'PAYMENT_SUCCESS') {
            const purchasePageURL = new URL(
                this.myImunifyService.getFixedPurchaseUrl(myImunifyState.purchase_page_url)
            );
            const eventURL = new URL(event.origin);

            // Validate the URL
            if (eventURL.origin !== purchasePageURL.origin) {
                return;
            }
            if (this.myImunifyService.purchaseWindow) {
                setTimeout(() => {
                    this.myImunifyService.purchaseWindow?.close();
                    this.modalService.open(PaymentSuccessComponent, {data: {
                            details: 'userside.my_imunify_payment_success_modal.details'
                        }});
                    this.clAnalytics.sendMyImunifyPurchaseEvent(myImunifyState.username as string);
                    this.promoModalRef.close();
                }, PAYMENT_SUCCESS_DELAY_MS);
            }
        }
    }
}
